@if (discount) {
  @if (isDifferentPrices) {
    <span class="ws-price__from"
          [class.ws-price__muted]="hasPicture"
          [translate]="'common.from'">
    </span>&nbsp;
    <span class="ws-price__old">{{ price | currencyFormat }}</span>
  }

  <span class="ws-price__value ws-price__value--discount"
        [style.color]="discountTheme.color()"> {{ price | tryToDiscountPrice: discount }} </span>

  <span class="ws-price__unit"
        [class.ws-price__muted]="hasPicture">
    <span class="ws-price__discount-currency"
          [style.color]="discountTheme.color()">{{ currency }}</span>@if (pieces) {<span>&nbsp;{{ perUnitText }}</span>}
  </span>
} @else {
  @if (isDifferentPrices) {
    <span class="ws-price__from"
          [class.ws-price__muted]="hasPicture"
          [translate]="'common.from'">
    </span>
  }

  <strong class="ws-price__value"> {{ price | currencyFormat }} </strong>

  <span class="ws-price__unit"
        [class.ws-price__muted]="hasPicture">
    {{ currency }}
    @if (pieces) {
      <span>&nbsp;{{ perUnitText }}</span>
    }
</span>
}
